export const appPaddingSm = 28;
export const appPaddingLg = 52;
export const pageHeaderFullHeight = 136;
export const uhfScreenMaxLg = 1083;
